import { library } from '@fortawesome/fontawesome-svg-core';

import * as icons from './Icons';

library.add(icons);
